import {
  FormControlLabel,
  FormGroup,
  Checkbox,
  Grid,
  TextField,

  Box,
  FormControl,

  MenuItem,
  Button,
  FormHelperText,
  Typography,
  Chip,
  Autocomplete,
  Modal,

} from "@mui/material";
import { React, useRef, useEffect, useState } from "react";

import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import BackButton from "../../common/button/backButton";

import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";

import { useDispatch, useSelector } from "react-redux";

import capRegistrationActions from "../../redux/capRegistration/actions";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { BsPlus } from "react-icons/bs";
import { FaPlus } from "react-icons/fa6";
import FileUploader from "../../common/fileupload";

export default function AddorUpdateCandidatureDocument() {
  const navigate = useNavigate();
  const location = useLocation();
  let id = location?.state?.id;

  const dispatch = useDispatch();

  const {

  } = useSelector((state) => state.masterFormsReducer);
  const { capDocuments } = useSelector(
    (state) => state.capReducer
  );

  useEffect(() => {
    if (id) {
      let currentCandidature  = capCandidatures?.find(obj=>obj.candidatureid == id )
      setValue("candidature",currentCandidature?.candidature)
      setValue("candidaturenotes",currentCandidature?.candidaturenotes)
      setValue("status",currentCandidature?.status)
      setDocuments(currentCandidature?.documentid?.map(did=> capDocuments?.find(doc=>doc.documenttypeid == did)?.documenttype))
    }
  }, [id])
  const [fileName, setFileName] = useState("");
  // const [candidature, setCandidature] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [open, setOpen] = useState(false);
  console.log(documents, 'documents')
  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);
  const { capCandidatures } = useSelector(state => state.capReducer)
  // const { capDocuments } = useSelector((state) => state.capReducer);
  useEffect(() => {
    dispatch({ type: capRegistrationActions.GET_CAP_CANDIDATURE })
  }, [])

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    trigger,
    control,
    setError,
    resetField,
    clearErrors,
    formState: { errors },
  } = useForm();





  useEffect(() => {


    // if (location.search === "?page=updatecapcandidaturedocument") {
    dispatch({
      type: capRegistrationActions.GET_CAP_COURSE_DOCUMENT,
    });
    // }


  }, []);

  const resetForm = () => {


    reset({});
  };




  const handleFileUpload = (e, id, documenttype,status,isactive,coursenotes) => {
    console.log(e, id)
    dispatch({
      type: capRegistrationActions.UPLOAD_DOCUMENT,
      payload: { documenttypeid: parseInt(id), file: e.target.files[0], userid: parseInt(backofficeTokenDetails?.id), documenttype: documenttype,status:status,isactive:isactive,coursenotes : coursenotes }
    })
    // setFiles([...files,{id:id,file:e.target.file}])
    // setMessage("");
    // const uploadedFile = e.target.files[0];
    // setUploadedFile(e.target.files[0]);
    // setFile(uploadedFile);
    // setFileName(uploadedFile ? uploadedFile.name : "");
  };
  const handleRemoveFile = (id, documenttype,status,isactive,coursenotes) => {
    console.log(id)
    dispatch({
      type: capRegistrationActions.REMOVE_DOCUMENT,
      payload: { documenttypeid: parseInt(id), userid: parseInt(backofficeTokenDetails?.id), documenttype: documenttype,status:status,isactive:isactive,coursenotes:coursenotes }
    })
  }
  const handleCreateCandidature = (data) => {
    data["userid"] = backofficeTokenDetails?.id;
    data["documentid"] = documents?.map(doc => capDocuments?.find(p => p.documenttype === doc)?.documenttypeid)
    // data["status"] = 
    dispatch({
      type: capRegistrationActions.CREATE_CAP_CANDIDATURE,
      payload: {
        data: data,

        navigate: navigate,
        resetForm: resetForm
      },
    });
  };

  const handleUpdateCandidature = (data) => {



    data["userid"] = backofficeTokenDetails?.id;
    data["candidatureid"] = id;
    data["documentid"] = documents?.map(doc => capDocuments?.find(p => p.documenttype === doc)?.documenttypeid)
    dispatch({
      type: capRegistrationActions.UPDATE_CAP_CANDIDATURE,
      payload: { data: data, navigate: navigate, resetForm: resetForm },
    });
  };






  return (
    <>

      <Grid container >
        <Grid item xs={12} md={8}>
          <TextField
            {...register("candidature", {
              required: "Cap Candidature Document Name is required",
            })}
            InputLabelProps={{
              shrink: !!watch("candidature"),
            }}

            error={!!errors.candidature}
            helperText={errors.candidature?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                CAP Candidature Name
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />

        </Grid>


         <Grid item md={6} xs={12} mt={2}>
                          <TextField
                            multiline
                            name="candidaturenotes"
                            {...register("candidaturenotes")}
                            label="Candidature Notes"
                            placeholder="Enter Candidature Notes"
                            fullWidth
                            rows={4}
                            error={!!errors.coursecategoryid}
                            helperText={errors.coursecategoryid?.message}
                            FormHelperTextProps={{
                              style: { margin: 0 },
                            }}
                            InputLabelProps={{
                              shrink: !!watch("candidaturenotes"),
                            }}
                         sx={{width:'133%'}} />
                        </Grid>
                
        

        <Grid container>
          <Grid
            item
            md={12}
            sx={{ display: "flex", justifyContent: "flex-end", py: 1 }}
          >
            <MauvelousPrimaryButton
              icon={<FaPlus />}
              title={"Add Document"}
              disabled={!watch('candidature')}
              handleClick={() => {
                setOpen(true)
              }

              }
            />
          </Grid>
          <Grid xs={12} lg={12}>
            {(documents && documents.length > 0) && documents.map(doc => {
              let document = capDocuments.find(d => d.documenttype === doc)
              return <FileUploader Filename={document.documenttype} fileUrl={document.sampleurl ?? ""} handleUpload={(e) => handleFileUpload(e, document.documenttypeid, document.documenttype,document.status,document.isactive,document.coursenotes)} handleRemoveFile={() => handleRemoveFile(document.documenttypeid, document.documenttype,document.status,document.isactive,document.coursenotes)} />

            })}
          </Grid>
        </Grid>






      </Grid>

      <Grid
        item
        md={12}
        pt={2}
        sx={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
      >
        <BackButton
          handleBack={() =>
            navigate(
              `/${Cookies.get(
                "mhet_mst_project"
              )}/cap-candidature-document?page=candidature-documentlist`
            )
          }
        />
        <BluePrimaryButton
          handleSubmit={handleSubmit(
            location.search !== "?page=updatecapcandidaturedocument"
              ? handleCreateCandidature
              : handleUpdateCandidature
          )}
          title={
            location.search === "?page=updatecapcandidaturedocument" ? "Update" : "Create"
          }
        />
      </Grid>



      <Modal
        open={open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: '80%',
            maxWidth: 600,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
            // display: "flex",
            // alignItems: "center",
            // flexDirection: "column",
            // justifyContent: "center",
          }}
        >
          <Grid item xs={12} md={12} xl={12}>
            <FormControl fullWidth>
              <Controller
                name="capdocuments"
                control={control}
                // defaultValue={[prevCourses?prevCourses : null]}
                defaultValue={[]}

                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    multiple
                    size="small"
                    fullWidth
                    sx={{ width: "100%" }}
                    // options={filteredCourseList.map(c => c.coursename) || []}
                    // options={filteredroleList ? filteredroleList.map(suggestion => suggestion.rolename) : []}
                    options={capDocuments ? capDocuments.filter(a=>a.isactive == '1').map(c => c.documenttype) : []}
                    value={documents ?? []}
                    onChange={(_, newValue) => setDocuments(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Documents"
                        error={!!errors.capdocuments}
                        helperText={errors.capdocuments?.message}
                      />
                    )}
                  />
                )}
              />
            </FormControl>
            <Box pt={2} display="flex" justifyContent="center">
              <BluePrimaryButton
                handleSubmit={() => { setOpen(false) }}
                title={
                  "Select"
                }
              />
            </Box>
          </Grid>
        </Box>
      </Modal>

    </>
  );
}
